import styled from '@emotion/styled'

export const Container = styled.div`
  margin: 0 50px;
  width: 350px;
  @media only screen and (max-width: 1110px) {
    width: auto;
  }
`

export const Image = styled.img`
  width: 80px;
  @media only screen and (max-width: 600px) {
    width: 32px;
    margin: 16px;
  }
`
